export default __webpack_public_path__ + "static/schedule-image-c1945e56eef8646b639a3bf62742f95a.png";